import { Routes } from '@angular/router';
import { ContentLayoutComponent } from './shared/components/layout/content-layout/content-layout.component';
import { AuthGuard } from './_services/auth/auth.guard';
// import { LoginComponent } from './components/login/login.component';  // Commented out - using mock auth instead
import { CompanyCodeGuard } from './_services/auth/company-guard/company-code.guard';
import { FullLayoutComponent } from './shared/components/layout/full-layout/full-layout.component';
import { Error404Component } from './pages/error-pages/error404/error404.component';

// Auth Components (Standalone)
import { SignInComponent } from './components/auth-main/sign-in/sign-in.component';
import { SignUpComponent } from './components/auth-main/sign-up/sign-up.component';
import { ResetPasswordComponent } from './components/auth-main/reset-password/reset-password.component';
import { VerifyOtpComponent } from './components/auth-main/verify-otp/verify-otp.component';

export const routes: Routes = [
    // Default route - Redirect to sign-in
    { path: '', redirectTo: 'auth/sign-in', pathMatch: 'full' },
    
    // Protected routes (Now enabled)
    {
        path: 'dashboard',
        component: ContentLayoutComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', loadChildren: () => import('./shared/components/layout/full-layout/components.routes').then(mod => mod.DASHBOARD_ROUTES) },
        ]
      },
      
      // Original login route (commented out - using mock auth system instead)
      // { path: 'login/:companyCode', component: LoginComponent, canActivate: [CompanyCodeGuard] },
      
      // Auth Routes (No guards - for login/signup flow)
      { path: 'auth/sign-in', component: SignInComponent },
      { path: 'auth/sign-up', component: SignUpComponent },
      { path: 'auth/reset-password', component: ResetPasswordComponent },
      { path: 'auth/verify-otp', component: VerifyOtpComponent },
      
      { path: '404', component: Error404Component }, // 404 component
      { path: '**', redirectTo: '/404' } // Catch-all for unknown routes
];